import { dateToTimeString } from "@circle-react/helpers/dateTimeHelpers/getLocalizedDate";
import { getDayName } from "@circle-react/helpers/dateTimeHelpers/getName";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

export const EventTimestamp = ({ eventData }: any) => {
  const {
    starts_at: startsAt,
    start_date: startDate,
    time_zone: timeZone,
    time_zone_abbreviations: timeZoneAbbreviations,
  } = eventData || {};
  const startDay = getDayName(startDate);

  return (
    <div className="flex items-center gap-x-2">
      <Icon type="16-calendar" size={16} className="text-default !w-4" />
      <Typography.LabelXs weight="normal">
        {`${startDay} ${dateToTimeString(
          startsAt,
          timeZone,
        )} ${timeZoneAbbreviations}`}
      </Typography.LabelXs>
    </div>
  );
};
